const state = {
  viewport: {width: 1, height: 1},
  showMenu: false,
}

const getters = {
  viewport: state => {
    return state.viewport
  },
  aspectRatio: state => {
    return state.viewport.width / state.viewport.height
  },
  portrait: state => {
    return (state.viewport.width / state.viewport.height) <= 1
  },
  showMenu: state => {
    return state.showMenu
  },
  overlapMenu: state => {
    return state.viewport.width <= 1100
  },
}

const actions = {
  toggleMenu ({commit, state}) {
    commit('setShowMenu',!state.showMenu);
  },
  openMenu ({commit}) {
    commit('setShowMenu',true);
  },
  closeMenu ({commit}) {
    commit('setShowMenu',false);
  },
}

const mutations = {
  setViewport (state, viewport) {
    state.viewport = viewport;
  },
  setShowMenu (state, visible) {
    state.showMenu = !!visible;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}